import { SxProps, Theme } from '@mui/material';

export const DpLinkText: SxProps<Theme> = {
	fontSize: 'var(--font-size-default)',
	fontWeight: 'bold',
	textTransform: 'uppercase',
	'&:hover': {
		color: '#2682E7',
	},
};
